import { useCallback, useLayoutEffect, useRef, useState } from "react";

export interface NotepadBoardIdentity {
  lessonId: string | number;
  sessionId: string;
}

/** Accept only server-resolved identities; never invent a pre-session board key. */
export function useNotepadBoardIdentity(lessonId: string | undefined) {
  const [identity, setIdentity] = useState<NotepadBoardIdentity | null>(null);
  const currentLessonIdRef = useRef(lessonId);
  useLayoutEffect(() => {
    currentLessonIdRef.current = lessonId;
  }, [lessonId]);
  const acceptIdentity = useCallback((resolved: NotepadBoardIdentity) => {
    if (
      !resolved.sessionId ||
      String(resolved.lessonId) !== currentLessonIdRef.current
    )
      return;
    setIdentity(resolved);
  }, []);
  return {
    boardSessionId:
      identity && String(identity.lessonId) === lessonId
        ? identity.sessionId
        : null,
    acceptIdentity,
  };
}
